import {FormControl} from "@angular/forms";

export function noSpecialCharacters(control: FormControl): { [key: string]: boolean } {
  const nameRegexp: RegExp = /[!@#$%^&*()+=[\]{};':"\\|,.<>/?]/;
  if (control.value && nameRegexp.test(control.value)) {
    return {"specialChars": true};
  }
}

export function noWhitespaces(control: FormControl): { [key: string]: boolean } {
  const nameRegexp: RegExp = /\s/;
  if (control.value && nameRegexp.test(control.value)) {
    return {"whitespaces": true};
  }
}
